import Vue from "vue";
import vqAccordion from './components/vqAccordion.vue'
import vqTabs from './components/vqTabs.vue'

import "../src/input.css";

document.querySelectorAll(".vq-component").forEach((el) => {
    new Vue({
        delimiters: ["[[", "]]"],
        el,
        components: {
            vqAccordion,
            vqTabs
        },
    });
});
require("./standalones/fetch.js");
require("./standalones/fetchExpertise.js");
require("./standalones/home.js");
require("./standalones/carousels.js");
require("./standalones/slider.js");
require("./standalones/scrollClass.js");
require("./standalones/utils.js");
require("./standalones/newsletter.js");
require("./standalones/document.js");
require("./standalones/menu.js");
